import React from 'react';
import { Text/*, Image*/, Rect } from 'react-konva';
import { isMobilePhone, isMobileTablet} from '../../library/calc';
import { fontFamily } from '../../library/constants';

const allLeft = 2.4;
const allTop = 3.1;
const circleDim = 7;

const openNewWindow = ({prId}) => {
    const href = '/merge/compare/' + prId;
    window.open(href, '_blank');
}

export class PendingMerge extends React.Component {

  render() {

      let killToolTip = false;

      let {
        left,
        top,
        cursorBecomesMove,
        cursorBecomesPointer,
        n,
        pr_id,
        fn,
        showToolTipFor,
        hideToolTip,
        isPedigree,
        pedigreeIsTall,
        // translatedLabels,
        userTouchedNode,
      } = this.props;


    if(n < 0) return null;

    let content = undefined;

    content = 'A merge is pending for this profile. Click to review the requested merge.';
    if(isMobileTablet() ){
      content = 'A merge is pending for this profile. Tap to review the requested merge.';
    }

    left += -3.25;
    top += 1.35;

    const pedigreeTop = ( pedigreeIsTall ? 15.8: 8.2);
    top += ( !isPedigree ? 24: pedigreeTop);

    top += allTop;
    left += allLeft;

    return <Text
      x={left}
      y={top}
      text={'+'}
      fontSize={6}
      fontFamily={fontFamily}
      fill='white'

      onTouchStart={()=>{
        userTouchedNode({
          node:n,
          callback: ()=>{
            openNewWindow({prId: pr_id})
          },
          fromWhere: 'PendingMerge'
        });
      }}

      onClick={()=>{
        if(isMobilePhone() ) return;
        killToolTip = true;
        openNewWindow({prId: pr_id})
      }}

      onMouseover={()=>{
        cursorBecomesPointer();
        if(!killToolTip) {

          let shift = {};

          if(!isPedigree){
            shift = {
              left: -5,
              top: 0,
            }
          } else {
            if(pedigreeIsTall){
              shift = {
                left: -5,
                top: -9,
              }
            } else {
              shift = {
                left: -5,
                top: -13,
              }
            }
          }


          showToolTipFor({
            node: n,
            placement: 'under',
            shiftLeftOnToolTip: shift.left,
            shiftTopOnToolTip: shift.top,
            content,
            runTranslatePhraseInToolTip: true,
            translateVarStrInToolTip: fn,
          })
        }
      }}
      onMouseout={()=>{
        hideToolTip();
        cursorBecomesMove();
      }}


    />;
  }
}



export class TransparentPendingMerge extends React.Component {

  render () {
    let {
      n,
      pr_id,
      left,
      top,
      userTouchedNode,
      isPedigree,
      pedigreeIsTall,
    } = this.props;

    if(n < 0) return null;

    left += -5;
    top += .4;

    const pedigreeTop = ( pedigreeIsTall ? 15.7: 8);
    top += ( !isPedigree ? 24: pedigreeTop);

    top += allTop;
    left += allLeft;

    return  <Rect
              fill="#2B66B5"
              x={left}
              y={top}
              width={circleDim}
              height={circleDim}
              cornerRadius={10}
              onTouchStart={()=>{
                userTouchedNode({
                  node:n,
                  callback: ()=>{
                    openNewWindow({prId: pr_id})
                  },
                  fromWhere: 'TransparentPendingMerge'
                });
              }}

            />

  }
}
